import AnimatedDotsText from '../../atoms/AnimatedDotsText';
import StyledButton from '../../atoms/StyledButton';
import {
  StyledDialog,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle
} from '../../atoms/styledModal';

function DeleteGroupModal({ open, onClose, handelDeleteGroupConfirm, loading, groupName = '' }) {
  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <StyledDialogTitle>Delete {groupName} Group</StyledDialogTitle>
      <StyledDialogContent>
        <p>Are you sure you want to delete {groupName || 'this'} group?</p>
        <p>
          Click <strong>Delete</strong> to confirm.
        </p>
      </StyledDialogContent>
      <StyledDialogActions>
        <StyledButton onClick={onClose} className="cancelButton" disabled={loading}>
          Cancel
        </StyledButton>
        <StyledButton
          onClick={handelDeleteGroupConfirm}
          className="confirmButton"
          disabled={loading}>
          {loading ? <AnimatedDotsText text={"Deleting"} /> : 'Confirm'}
        </StyledButton>
      </StyledDialogActions>
    </StyledDialog>
  );
}

export default DeleteGroupModal;
